<template>
  <svg
    version="1.1"
    id="레이어_2_1_"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 56.2 80.3"
    style="enable-background:new 0 0 56.2 80.3;"
    xml:space="preserve"
  >
    <path class="st0" d="M17,14.8" />
    <path
      class="st1"
      d="M44.7,8.9C44.7,8.9,44.7,8.9,44.7,8.9C44.7,9,44.7,9,44.7,8.9v0.3c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0,0,0
	s0,0,0,0c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.3c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.1-0.1,0.2l-0.1,0.1l-6.5,7
	c-0.4,0.4-0.9,0.6-1.5,0.6c-1.1,0-2-0.9-2-2c0-0.5,0.2-1,0.5-1.4l3.5-3.8H13.5c-1.1,0-2-0.9-2-2s0.9-2,2-2h24.6l-3.5-3.8
	c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2-0.6,2.8,0.1l6.6,7.2c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0
	c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.2C44.7,8.8,44.7,8.9,44.7,8.9z"
    />
    <path
      class="st1"
      d="M44.7,9.5c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0C44.6,9.7,44.7,9.6,44.7,9.5z"
    />
    <path
      class="st1"
      d="M44.7,9.1C44.7,9.2,44.7,9.2,44.7,9.1l0-0.1C44.7,9,44.7,9.1,44.7,9.1z"
    />
    <path
      class="st1"
      d="M44.2,10.5C44.2,10.6,44.2,10.6,44.2,10.5l-0.1,0.1L44.2,10.5z"
    />
    <path
      class="st1"
      d="M44.7,9.1c0,0.3,0,0.7-0.2,1c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0
	C44.7,9.4,44.7,9.3,44.7,9.1l0-0.1C44.7,9,44.7,9.1,44.7,9.1z"
    />
    <path
      class="st1"
      d="M44.7,9.5c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0C44.6,9.7,44.7,9.6,44.7,9.5z"
    />
    <path
      class="st1"
      d="M44.7,9.1C44.7,9.2,44.7,9.2,44.7,9.1l0-0.1C44.7,9,44.7,9.1,44.7,9.1z"
    />
    <path
      class="st1"
      d="M28.1,24C12.6,24,0,36.6,0,52.1c0,15.5,12.6,28.1,28.1,28.1c15.5,0,28.1-12.6,28.1-28.1v0
	C56.2,36.6,43.6,24,28.1,24z"
    />
    <path
      class="st2"
      d="M34.5,47.2c-1.6-1.5-3.7-2.3-5.9-2.3c-2.3,0-3.9,0.9-3.9,2.7c0,3.9,12.4,2.5,12.4,10.2c0,3.6-2.5,6.2-7,6.8v4.1
	h-3v-4c-2.8-0.2-5.5-1.3-7.7-3.1l2.1-3.1c1.8,1.6,4.2,2.5,6.7,2.5c3.2,0,4.6-1,4.6-2.8c0-4.1-12.4-2.8-12.4-10.3
	c0-3.7,2.6-6.2,6.7-6.7v-4H30v4c2.5,0.3,4.9,1.5,6.7,3.2L34.5,47.2z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SendFillIcon',
};
</script>

<style scoped>
.st0 {
  fill: #121212;
  stroke: #000000;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st1 {
  fill: #3e0ba5;
}
.st2 {
  fill: #ffffff;
}
</style>
